"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CraigslistApiSearchCategory = void 0;
var CraigslistApiSearchCategory;
(function (CraigslistApiSearchCategory) {
    CraigslistApiSearchCategory["carsAndTrucks"] = "cta";
    CraigslistApiSearchCategory["furniture"] = "fua";
    CraigslistApiSearchCategory["garageSales"] = "gms";
})(CraigslistApiSearchCategory || (exports.CraigslistApiSearchCategory = CraigslistApiSearchCategory = {}));
